<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Magic`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_66bfdeffb0__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_66bfdeffb0__a)"><path d="M5 33.5L9.17857 35.82143 11.5 40 13.82143 35.82143 18 33.5 13.82143 31.17857 11.5 27 9.17857 31.17857 5 33.5zM35 12L37.57143 13.42857 39 16 40.42857 13.42857 43 12 40.42857 10.57143 39 8 37.57143 10.57143 35 12zM27 19L28.92857 20.07143 30 22 31.07143 20.07143 33 19 31.07143 17.92857 30 16 28.92857 17.92857 27 19zM18 8L20.57143 9.42857 22 12 23.42857 9.42857 26 8 23.42857 6.571429999999999 22 4 20.57143 6.571429999999999 18 8z"/><path d="M10.956018220520019,15.524124145507812L49.12196822052002,15.524124145507812C50.37026822052002,15.524124145507812,51.38226822052002,14.628694145507811,51.38226822052002,13.524124145507812C51.38226822052002,12.419554145507812,50.37026822052002,11.524124145507812,49.12196822052002,11.524124145507812L10.956018220520019,11.524124145507812C9.70765822052002,11.524124145507812,8.69566822052002,12.419554145507812,8.69566822052002,13.524124145507812C8.69566822052002,14.628694145507811,9.70765822052002,15.524124145507812,10.956018220520019,15.524124145507812Z" fill-rule="evenodd" transform="scale(1 -1) rotate(-45 -19.126 0)"/></g></svg>
</template>
<script>

export default {
  name: 'IconMagic',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
